export default "__VITE_ASSET__d7ee69d3__"